/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';


export interface DashboardProjectsControllerDeleteUpdateV1$Params {
  projectId: string;
  updateId: string;
}

export function dashboardProjectsControllerDeleteUpdateV1(http: HttpClient, rootUrl: string, params: DashboardProjectsControllerDeleteUpdateV1$Params, context?: HttpContext): Observable<StrictHttpResponse<{
'message'?: string;
'updateId'?: string;
}>> {
  const rb = new RequestBuilder(rootUrl, dashboardProjectsControllerDeleteUpdateV1.PATH, 'delete');
  if (params) {
    rb.path('projectId', params.projectId, {});
    rb.path('updateId', params.updateId, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<{
      'message'?: string;
      'updateId'?: string;
      }>;
    })
  );
}

dashboardProjectsControllerDeleteUpdateV1.PATH = '/v1/dashboard/projects/{projectId}/updates/{updateId}';
